import { oktaAuth } from '../okta-auth';
import { config } from '../../config/env';

export interface ServiceAppStatusResponse {
  configured: boolean;
  source: 'database' | 'env' | 'none';
  client_id?: string;
  app_id?: string;
  jwks_uri?: string;
  is_localhost?: boolean;
  requires_manual_key_upload?: boolean;
  scopes_granted?: string[];
  scopes_failed?: string[];
  provisioned_at?: string | null;
  provisioned_by?: string | null;
}

export interface ServiceAppProvisionResponse {
  status: 'already_configured' | 'provisioned';
  source?: 'database' | 'env';
  client_id?: string;
  app_id?: string;
  jwks_uri?: string;
  is_localhost?: boolean;
  requires_manual_key_upload?: boolean;
  scopes_granted?: string[];
  scopes_failed?: string[];
  provisioned_at?: string;
  provisioned_by?: string;
}

async function authHeaders(): Promise<Record<string, string>> {
  const token = oktaAuth.getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const BASE = config.gatewayUrl;

export async function getServiceAppStatus(): Promise<ServiceAppStatusResponse> {
  const res = await fetch(`${BASE}/api/admin/okta/service-app`, {
    method: 'GET',
    credentials: 'include',
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Failed to load service app status (${res.status})`);
  }
  return res.json();
}

export async function provisionServiceApp(): Promise<ServiceAppProvisionResponse> {
  const res = await fetch(`${BASE}/api/admin/okta/service-app/provision`, {
    method: 'POST',
    credentials: 'include',
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || `Failed to provision service app (${res.status})`);
    (err as any).code = body.error;
    throw err;
  }
  return res.json();
}
